module.exports = __webpack_public_path__ + "img/10-WHEEL.058fda27.png";